import cx from 'classnames'
import startCase from 'lodash/startCase'
import { Sun2, ColorSwatch2, Palette } from 'blaze-ui/icons/20'
import { Check02 } from 'blaze-ui/icons/16'
import { VisualStyle } from 'types'
import Styles from './V4VisualStyleSelection.module.scss'

interface Props {
  style: VisualStyle
  isSelected: boolean
  onSelect: (id: number) => void
}

export const V4StyleCard = ({ style, isSelected, onSelect }: Props) => {
  const { lighting, color, contrast } = style.metadata ?? {}

  return (
    <button
      type="button"
      className={cx(Styles.styleCard, { [Styles.styleCardSelected]: isSelected })}
      onClick={() => onSelect(style.id)}
      aria-pressed={isSelected}
    >
      <div className={Styles.cardThumbnailWrap}>
        <img src={style.cover_image_url} alt={style.name} className={Styles.cardThumbnail} />
      </div>

      <div className={Styles.cardBody}>
        <div className={Styles.cardTextBlock}>
          <span className={Styles.cardName}>{style.name}</span>
          {style.metadata?.display_description && (
            <span className={Styles.cardDescription}>{style.metadata.display_description}</span>
          )}
        </div>
        <div className={Styles.cardTags}>
          {lighting && (
            <span className={Styles.tag}>
              <Sun2 size={16} color="var(--dark-60)" />
              {startCase(lighting)}
            </span>
          )}
          {color && (
            <span className={Styles.tag}>
              <ColorSwatch2 size={16} color="var(--dark-60)" />
              {startCase(color)}
            </span>
          )}
          {contrast && (
            <span className={Styles.tag}>
              <Palette size={16} color="var(--dark-60)" />
              {startCase(contrast)}
            </span>
          )}
        </div>
      </div>

      <div className={cx(Styles.checkIndicator, { [Styles.checkIndicatorSelected]: isSelected })} aria-hidden>
        {isSelected && <Check02 size={15} color="white" />}
      </div>
    </button>
  )
}
